import React from 'react';
import './PartnersSection.css';

import BrandArtistry from '../assets/01 Brand Artistry.svg';
import Actstitude from '../assets/02 Actstitude.svg';
import BluePocket from '../assets/03 The Blue Pocket.svg';

const PartnersSection = () => {
  return (
    <section className="partners-section">
      <div className="partners-content">
        {/* Left: Text Content */}
        <div className="partners-left">
          <h2 className="partners-colored-title">
            <span style={{ color: '#ed448d' }}>C</span>
            <span style={{ color: '#f6953d' }}>o</span>
            <span style={{ color: '#f28aa6' }}>l</span>
            <span style={{ color: '#39c2b1' }}>l</span>
            <span style={{ color: '#ed448d' }}>a</span>
            <span style={{ color: '#f6953d' }}>b</span>
            <span style={{ color: '#f28aa6' }}>o</span>
            <span style={{ color: '#39c2b1' }}>r</span>
            <span style={{ color: '#ed448d' }}>a</span>
            <span style={{ color: '#f6953d' }}>t</span>
            <span style={{ color: '#f28aa6' }}>i</span>
            <span style={{ color: '#39c2b1' }}>v</span>
            <span style={{ color: '#ed448d' }}>e</span>
            <br />
            <span style={{ color: '#f6953d' }}>P</span>
            <span style={{ color: '#f28aa6' }}>a</span>
            <span style={{ color: '#39c2b1' }}>r</span>
            <span style={{ color: '#ed448d' }}>t</span>
            <span style={{ color: '#f6953d' }}>n</span>
            <span style={{ color: '#f28aa6' }}>e</span>
            <span style={{ color: '#39c2b1' }}>r</span>
            <span style={{ color: '#ed448d' }}>s</span>
            <span style={{ color: '#f6953d' }}>h</span>
            <span style={{ color: '#f28aa6' }}>i</span>
            <span style={{ color: '#39c2b1' }}>p</span>
          </h2>

          <p className="partners-description">
            Empower your marketing campaigns with our dynamic <br />
            collaboration between Actstitude, Brand Artistry <br />
            and The Blue Pocket.
          </p>
          <p className="partners-description">
            Together we transform your ideas into captivating <br />
            realities, seamlessly integrating creative concepts <br />
            with flawless event execution. From immersive visuals <br />
            to impactful events, we craft experiences that set <br />
            your brand apart. Let’s elevate your brand together.
          </p>

          <a href="#contact">
            <button className="partners-button">Book a Meeting</button>
          </a>
        </div>

        {/* Right: Logos Cascade */}
        <div className="partners-right">
          <img
            src="/images/OMO_Collaboration Partners.png"
            alt="OMO Collaborative Partnership"
            className="partners-right-image"
          />
        </div>
      </div>
    </section>
  );
};

export default PartnersSection;
